export default "<p>Practice-association works!</p>\n";